
export const getYearMonthDay = () =>{
    const date = new Date();
    const year = date.getFullYear();
    // 月份从 0 开始计数，所以要加 1，并且保证是两位数
    const month = String(date.getMonth() + 1).padStart(2, '0');
    // 日期保证是两位数
    const day = String(date.getDate()).padStart(2, '0');
    return {
        year,
        month,
        day
    };
}

/**
 * 检测设备类型和操作系统
 */
export const detectDeviceAndOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 设备类型检测
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent);
    const isDesktop = !isMobile && !isTablet;

    // 操作系统检测
    let os = 'Unknown';
    if (/Windows NT/i.test(userAgent)) {
        os = 'Windows';
    } else if (/iOS|iPhone|iPad|iPod/i.test(userAgent)) {
        os = 'iOS';
    } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
        os = 'macOS';
    } else if (/Linux/i.test(userAgent)) {
        os = 'Linux';
    } else if (/Android/i.test(userAgent)) {
        os = 'Android';
    }

    console.log(os)
    return {
        isMobile,
        isTablet,
        isDesktop,
        sysOs:os
    };
};

export default detectDeviceAndOS;